module.exports = __webpack_public_path__ + "static/index/img/baikal-705.eb5cc6be.jpg";